import plugin from 'tailwindcss/plugin';

const containerPadding = {
  default: '1rem',
  xs: '2.5rem',
  sm: '5rem',
  xl: '10rem',
};

export default plugin(function ({ addComponents, theme }) {
  const breakpoints = theme('screens');
  const mediaQueries = Object.keys(breakpoints).map((breakpoint) => {
    const width = breakpoints[breakpoint];

    return {
      [`@media (min-width: ${width})`]: {
        '.container': {
          'grid-gap': breakpoint === 'lg' && theme('gap')['4'],
          'padding-left': containerPadding[breakpoint],
          'padding-right': containerPadding[breakpoint],
        },
      },
    };
  });

  addComponents([
    {
      '.container': {
        display: 'grid',
        width: '100%',
        'max-width': theme('screens.2xl'),
        'grid-template-columns': theme('gridTemplateColumns')['12'],
        'grid-gap': theme('gap')['3'],
        'padding-left': '1rem',
        'padding-right': '1rem',
        'margin-right': 'auto',
        'margin-left': 'auto',
      },
    },
    ...mediaQueries,
  ]);
});
